module.exports = __webpack_public_path__ + "static/media/cacao2.5353c6a5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/cacao/cacao2.jpeg
// module id = 47
// module chunks = 0